import {useState} from 'react';

const CREDENTIALS_STORAGE_KEY = 'cashia_checkout_credentials';

interface CredentialValues {
  keyId: string;
  secretKey: string;
  terminalId: string;
  timestamp: number;
}

export const useCredentialsV2 = () => {
  const [showPassword, setShowPassword] = useState(false);

  const saveCredentials = (
    keyId: string,
    secretKey: string,
    terminalId: string
  ) => {
    const data: CredentialValues = {
      keyId,
      secretKey,
      terminalId,
      timestamp: Date.now(),
    };
    localStorage.setItem(CREDENTIALS_STORAGE_KEY, JSON.stringify(data));
  };

  const getCredentials = (): CredentialValues | null => {
    const stored = localStorage.getItem(CREDENTIALS_STORAGE_KEY);
    if (!stored) return null;

    const data = JSON.parse(stored) as CredentialValues;
    const thirtyMinutes = 30 * 60 * 1000;
    const isExpired = Date.now() - data.timestamp > thirtyMinutes;

    if (isExpired) {
      localStorage.removeItem(CREDENTIALS_STORAGE_KEY);
      return null;
    }

    return data;
  };

  const clearCredentials = () => {
    localStorage.removeItem(CREDENTIALS_STORAGE_KEY);
  };

  return {
    showPassword,
    setShowPassword,
    saveCredentials,
    getCredentials,
    clearCredentials,
  };
};
